import { NgModule } from '@angular/core'
import { SubjectUserBadgeComponent } from './subject-user-badge.component'
import { CommonModule } from '@angular/common'

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        SubjectUserBadgeComponent,
    ],
    exports: [
        SubjectUserBadgeComponent,
    ]
})
export class SubjectUserBadgeModule {}